export class ProductResult {
  private name: string;
  private ean: string;
  private presentation: string;

  setName(value: string): void {
    this.name = value;
  }

  getName(): string {
    return this.name;
  }

  setPresentation(value: string): void {
    this.presentation = value;
  }

  getPresentation(): string {
    return this.presentation;
  }

  setEan(value: string): void {
    this.ean = value;
  }

  getEan(): string {
    return this.ean;
  }
}
